let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9kmyl")).then(() => parcelRequire('3yude'));